import { fmlmBookNowClickAction } from "../../../Actions/UIActions/FmlmViewInformation/FmlmBookNowClickAction";
import { fmlmSelectJourneyAction } from "../../../Actions/UIActions/FmlmViewInformation/FmlmSelectJourneyAction";
import { fmlmUpdateFilterAction } from "../../../Actions/UIActions/FmlmViewInformation/FmlmUpdateFilterAction";
import { getFmlmViewInformationAction } from "../../../Actions/UIActions/FmlmViewInformation/GetFmlmViewInformationAction";
import { modifySearchAction } from "../../../Actions/UIActions/TrainOffer/ModifySearchAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree, trainOfferEvtTree } from "../../../Orchestrator/ConstantTree";
import { fmlmSearchTree } from "../../../Orchestrator/ConstantTree/FmlmSearch/FmlmSearchTree";
import { fmlmViewInfoTree } from "../../../Orchestrator/ConstantTree/FmlmSearch/FmlmViewInformationTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmBookNowClickActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FmlmBookNowClickActionParams";
import { IFmlmSelectJourneyActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/fmlmSelectJourneyActionParams";
import { IGetFmlmViewInformationActionRequestParams } from "../../../Orchestrator/Types/Interface/ActionParams/GetFmlmViewInformationActionParams";
import { IModifySearchActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/ModifySearchActionParams";
import { IFmlmFilter, IFmlmView } from "../../../Orchestrator/Types/Interface/IFmlmView";
import { FmlmViewContext } from "../Context/FmlmViewContext";

class fmlmViewInformationStep extends StepFlow {
  get stepName() {
    return "FmlmViewInformation_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<IFmlmSelectJourneyActionParams, void>({
        eventName: fmlmSearchTree.SelectJourney.Select,
        handler: async (payload) => {
          let context = this.getCtx<FmlmViewContext>("fmlmViewContext")!;
          await fmlmSelectJourneyAction.setParams({
            id: payload.data?.id!,
            fmlmViewList: payload.data?.fmlmViewList!,
            trainType: payload.data?.trainType!
          });
          await fmlmSelectJourneyAction.execute();
          if (fmlmSelectJourneyAction.status.executionStatus === ExecutionStatus.SUCCESS) {
            context.selectedFmlmJourney = fmlmSelectJourneyAction.result!;
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IModifySearchActionParams, void>({
        eventName: trainOfferEvtTree.Offer.ModifySearchClose.Click,
        handler: (payload) => {
          modifySearchAction.setParams(payload.data!);
          modifySearchAction.execute();

          updateRecoilState("selectedOutboundTrainAtom", null);

          const context = this.getCtx<FmlmViewContext>("fmlmViewContext")!;
          context.routeTo = ["SearchFlow"];
          this.next();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IGetFmlmViewInformationActionRequestParams, void>({
        eventName: evtTree.SearchBar.TimeSelectModal.Click,
        handler: async (payload) => {
          _eventBus.emit({
            eventName: fmlmViewInfoTree.Filter.GetFmlmOffers,
            data: payload.data!
          })
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IModifySearchActionParams, void>({
        eventName: trainOfferEvtTree.Offer.ModifySearch.Click,
        handler: async (payload) => {
          modifySearchAction.setParams(payload.data!);
          modifySearchAction.execute();

          const fmlmViewContext = this.getCtx<FmlmViewContext>("fmlmViewContext")!
          fmlmViewContext.routeTo = ["SearchFlow"]
          this.next()
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IGetFmlmViewInformationActionRequestParams, void>({
        eventName: fmlmViewInfoTree.Filter.GetFmlmOffers,
        handler: async (payload) => {
          const { search, fmlmFilter, fmlmViewList, trainType } = payload.data!
          getFmlmViewInformationAction.setParams({
            trainType: trainType,
            search,
            fmlmFilter,
            isTimerVisible: false,
            fmlmViewList: fmlmViewList,
            isFromPopUp: payload.data?.isFromPopUp || false,
          })
          await getFmlmViewInformationAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IGetFmlmViewInformationActionRequestParams, void>({
        eventName: fmlmSearchTree.LoadMore.Click,
        handler: async (payload) => {
            getFmlmViewInformationAction.setParams({
              trainType: payload.data?.trainType!,
              search: payload.data?.search!,
              fmlmFilter: payload.data?.fmlmFilter!,
              lastOfferDate: payload.data?.lastOfferDate || null,
              fmlmViewList: payload.data?.fmlmViewList,
              fmlmViewOffersMap: payload.data?.fmlmViewOffersMap,
              isTimerVisible: false,
              isFromPopUp: false,
            });
            await getFmlmViewInformationAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IFmlmBookNowClickActionParams, void>({
        eventName: fmlmViewInfoTree.Booking.BookNow,
        handler: async (payload) => {
          const {selectedJourney, fmlmViewOffersMap, offersRequest, passengerSpecificationsTypes, trainType, selectedTrainLegs } = payload.data!;
          const fmlmViewContext = this.getCtx<FmlmViewContext>("fmlmViewContext")!;
          fmlmViewContext.selectedFmlmJourney = selectedJourney;

          fmlmBookNowClickAction.setParams({
            trainType: trainType,
            selectedJourney: selectedJourney!,
            fmlmViewOffersMap: fmlmViewOffersMap,
            offersRequest: offersRequest,
            passengerSpecificationsTypes: passengerSpecificationsTypes,
            selectedTrainLegs: selectedTrainLegs
          })
          await fmlmBookNowClickAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IFmlmFilter, void>({
        eventName: fmlmViewInfoTree.Filter.UpdateFilter,
        handler: async (payload) => {
          fmlmUpdateFilterAction.setParams(payload.data!);
          await fmlmUpdateFilterAction.execute();
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("Fmlm View information Flow..............");
  }
}

export const fmlmViewInformationStepDefination = new StepDefinition({
  stepName: "FmlmViewInformation_Step",
  stepClass: fmlmViewInformationStep,
});
